// Returns name for submission model based of promotion config
export function submissionModelName(promotion, capitalise = false) {
  var modelName = promotion.competition ? 'entry' : 'claim';

  if (capitalise) {
    modelName = String(modelName).charAt(0).toUpperCase() + String(modelName).slice(1);
  }

  return modelName;
}
